import SurplusForm from "@/views/SurplusForm.vue"
import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store/index"
//import LandingPage from "@/views/LandingPage"
import LandingPage from "@/views/LandingPage/indexBis.vue"
//import LandingPageAll2 from "@/views/LandingPage/landingPageAll2.vue"
import ManagerLanding from "@/views/ManagerLanding"
import NutriQuest from "@/views/ConsumerDashboardPage/NutriQuest.vue"
import DiagnosticPage from "@/views/DiagnosticPage"
import KeyMeasuresPage from "@/views/KeyMeasuresPage"
import KeyMeasuresHome from "@/views/KeyMeasuresPage/KeyMeasuresHome"
import KeyMeasurePage from "@/views/KeyMeasuresPage/KeyMeasurePage"
import GeneratePosterPage from "@/views/GeneratePosterPage"
import CanteensPage from "@/views/CanteensPage"
import CanteenWidget from "@/views/CanteensPage/CanteenWidget"
import CanteenSearchLanding from "@/views/CanteenSearchLanding"
import CanteensHome from "@/views/CanteensPage/CanteensHome"
import CanteenPage from "@/views/CanteensPage/CanteenPage"
import LegalNotices from "@/views/LegalNotices"
import AccountSummaryPage from "@/views/AccountSummaryPage"
import AccountEditor from "@/views/AccountSummaryPage/AccountEditor"
import PasswordChangeEditor from "@/views/AccountSummaryPage/PasswordChangeEditor"
import AccountDeletion from "@/views/AccountSummaryPage/AccountDeletion"
import BlogsPage from "@/views/BlogsPage"
import BlogsHome from "@/views/BlogsPage/BlogsHome"
import BlogPage from "@/views/BlogsPage/BlogPage"
import SurveyLinksPage from "@/views/SurveyLinksPage"
import SurveyLinksHome from "@/views/SurveyLinksPage/SurveyLinksHome"
import EatingStudyPage from "@/views/EatingStudyPage"
import EatingStudyHome from "@/views/EatingStudyPage/EatingStudyHome"
import CreateEatingStudy from "@/views/EatingStudyPage/CreateEatingStudy"
import EatingExperiencePage from "@/views/EatingExperiencePage"
import CreateEatingExperience from "../views/EatingExperiencePage/CreateEatingExperience"
import ConcernsPage from "@/views/ConcernsPage"
import CreateConcerns from "../views/ConcernsPage/CreateConcerns"
import PartnersPage from "@/views/PartnersPage"
import PartnersHome from "@/views/PartnersPage/PartnersHome"
import PartnerPage from "@/views/PartnersPage/PartnerPage"
import NewPartner from "@/views/NewPartner"
import NotFound from "@/views/NotFound"
import CGU from "@/views/CGU.vue"
import PrivacyPolicy from "@/views/PrivacyPolicy"
import ManagementPage from "@/views/ManagementPage"
import PendingActions from "@/views/PendingActions"
import CanteenEditor from "@/views/CanteenEditor"
import CanteenForm from "@/views/CanteenEditor/CanteenForm"
import SatelliteManagement from "@/views/CanteenEditor/SatelliteManagement"
import CanteenManagers from "@/views/CanteenEditor/CanteenManagers"
import CanteenStaff from "@/views/CanteenEditor/CanteenStaff"
import CanteenConsumers from "@/views/CanteenEditor/CanteenConsumers"
import CanteenGeneratePoster from "@/views/CanteenEditor/CanteenGeneratePoster"
import CanteenDeletion from "@/views/CanteenEditor/CanteenDeletion"
import PublicationForm from "@/views/CanteenEditor/PublicationForm"
import PublishSatellites from "@/views/CanteenEditor/PublishSatellites"
import DiagnosticTunnel from "@/views/DiagnosticTunnel"
import DiagnosticsImporter from "@/views/DiagnosticsImporter"
import DiagnosticImportPage from "@/views/DiagnosticsImporter/DiagnosticImportPage"
import PublicCanteenStatisticsPage from "@/views/PublicCanteenStatisticsPage"
import AccessibilityDeclaration from "@/views/AccessibilityDeclaration"
import ContactPage from "@/views/ContactPage"
import PurchasesHome from "@/views/PurchasesHome"
import PurchasePage from "@/views/PurchasePage"
import PurchasesImporter from "@/views/PurchasesImporter"
import PurchasesSummary from "@/views/PurchasesSummary"
import CommunityPage from "@/views/CommunityPage"
import FaqPage from "@/views/FaqPage"
import SiteMap from "@/views/SiteMap"
import DeveloperPage from "@/views/DeveloperPage"
import ImpactMeasuresPage from "@/views/ImpactMeasuresPage"
import DashboardManager from "@/views/DashboardManager"
import ManagerDashboard from "@/views/ManagerDashboard.vue"
import WorkerDashboard from "@/views/WorkerDashboard.vue"
import SupervisorDashboard from "@/views/SupervisorDashboard.vue"
import CookDashboard from "@/views/CookDashboard.vue"
import SurplusManagerDashboard from "@/views/SurplusManagerDashboard.vue"
// Retour repas adulte : vue renommée depuis l'ancien PoC `ConsumerDashboard2`.
import AdultMealFeedback from "@/views/AdultMealFeedback.vue"
import NutritionistDashboard from "@/views/NutritionistDashboard.vue"
import ConsumerDashboard from "@/views/ConsumerDashboard.vue"
import TerritoryCanteens from "@/views/TerritoryCanteens"
import VideoTutorial from "@/views/VideoTutorial"
import MyProgress from "@/views/MyProgress"
import Constants from "@/constants"
import BlankPage from "@/views/BlankPage"
import ActionPlan from "@/views/ActionPlan"
import CreateAction from "@/views/ActionPlan/CreateAction"
import ActionDetails from "../views/ActionPlan/ActionDetails"
import ContactLabSoft from "@/views/ContactLabSoft.vue"
import ManageResults from "@/views/ManageResults"
import ActionResults from "@/views/ActionResults"
import RestaurantDashboardPage from "@/views/RestaurantDashboardPage"
import WasteDiagnosticPage from "@/views/WasteDiagnosticPage"
import WasteDiagnosticResumePage from "@/views/WasteDiagnosticResumePage"
import CantineNewDashboard from "@/views/CantineNewDashboard"
import KezakoPage from "@/views/KezakoPage"
import NextMeeting from "../views/NextMeeting"

// import WasteActionsPage from "@/views/WasteActionsPage"
// import WasteActionsHome from "@/views/WasteActionsPage/WasteActionsHome.vue"
// import WasteActionPage from "@/views/WasteActionsPage/WasteActionPage.vue"
import GestionnairePage from "@/views/GestionnairePage"
import GestionnairePage2 from "@/views/GestionnairePage/GestionnairePage2.vue"
import NutritionistePage from "@/views/NutritionistePage"
import NutritionistePage2 from "@/views/NutritionistePage/NutritionistePage2.vue"
import ConvivePage from "@/views/ConvivePage"
import ConvivePage2 from "@/views/ConvivePage/ConvivePage2.vue"

Vue.use(VueRouter)

import ServiceList from "@/views/ServicePage/ServiceList.vue"
import ServiceForm from "@/views/ServicePage/ServiceForm.vue"
import ServiceLevelForm from "@/views/ServicePage/ServiceLevelForm.vue"

const routes = [
  // Accès direct aux formulaires principaux
  {
    path: "/form-surplus",
    name: "SurplusFormPage",
    component: SurplusForm,
    meta: {
      title: "Formulaire Surplus",
      authenticationRequired: true,
      requiredPermissions: ["MANAGER", "SUPERVISOR", "WORKER"],
    },
  },
  // Dashboards par rôle
  {
    path: "/dashboard-manager",
    name: "ManagerDashboard",
    component: ManagerDashboard,
    meta: {
      title: "Tableau de bord gestionnaire",
      authenticationRequired: true,
      requiredPermissions: ["MANAGER"],
    },
  },
  {
    path: "/dashboard-worker",
    name: "WorkerDashboard",
    component: WorkerDashboard,
    meta: {
      title: "Tableau de bord agent de service",
      authenticationRequired: true,
      requiredPermissions: ["WORKER"],
    },
  },
  {
    path: "/dashboard-supervisor",
    name: "SupervisorDashboard",
    component: SupervisorDashboard,
    meta: {
      title: "Tableau de bord animateur",
      authenticationRequired: true,
      requiredPermissions: ["SUPERVISOR"],
    },
  },
  {
    path: "/dashboard-cook",
    name: "CookDashboard",
    component: CookDashboard,
    meta: {
      title: "Tableau de bord cuisinier",
      authenticationRequired: true,
      requiredPermissions: ["COOK"],
    },
  },
  {
    path: "/dashboard-surplus-manager",
    name: "SurplusManagerDashboard",
    component: SurplusManagerDashboard,
    meta: {
      title: "Tableau de bord gestionnaire surplus",
      authenticationRequired: true,
      // Le rôle SURPLUSMANAGER existe au référentiel (SCOPE_BY_JOB : MULTI_CANTEEN).
      // La garde lit les rôles effectifs via `store.getters.userRoles`, jamais `loggedUser.job`.
      requiredPermissions: ["SURPLUSMANAGER"],
    },
  },
  {
    // Une seule route : les deux anciennes (`/dashboard-consumer2` et
    // `/dashboard-consumer3`) pointaient sur le même composant, à la seule
    // différence d'une prop `wasteVersion` qui n'était plus lue.
    path: "/retour-repas",
    name: "AdultMealFeedback",
    component: AdultMealFeedback,
    meta: {
      title: "Mon avis sur le repas",
      authenticationRequired: true,
      requiredPermissions: ["CONSUMER"],
    },
  },
  {
    path: "/dashboard-nutritionist",
    name: "NutritionistDashboard",
    component: NutritionistDashboard,
    meta: {
      title: "Tableau de bord des nutritionistes",
      authenticationRequired: true,
      // Le chercheur y accède aussi (R2, arbitrage du 2026-08-20) : la restitution agrégée est son
      // objet. Les deux routes du tableau de bord sont ouvertes ensemble — n'en ouvrir qu'une
      // ferait dépendre l'accès du lien emprunté.
      requiredPermissions: ["NUTRITIONIST", "RESEARCHER"],
    },
  },
  {
    path: "/mon-espace",
    name: "ConsumerDashboard",
    component: ConsumerDashboard,
    meta: {
      title: "Mon espace convive",
      authenticationRequired: true,
      requiredPermissions: ["CONSUMER"],
    },
  },
  {
    path: "/services",
    component: { render: (h) => h("router-view") },
    children: [
      {
        path: "",
        name: "ServiceList",
        component: ServiceList,
        meta: {
          title: "Liste des services",
          authenticationRequired: true,
          requiredPermissions: ["MANAGER", "SUPERVISOR"],
        },
      },
      {
        path: "ajouter",
        name: "ServiceForm",
        component: ServiceForm,
        meta: {
          title: "Ajouter un service",
          authenticationRequired: true,
          requiredPermissions: ["MANAGER", "SUPERVISOR"],
        },
      },
      {
        path: ":serviceId/niveaux/ajouter",
        name: "ServiceLevelForm",
        component: ServiceLevelForm,
        meta: {
          title: "Ajouter un niveau de service",
          authenticationRequired: true,
          requiredPermissions: ["MANAGER", "SUPERVISOR"],
        },
        props: true,
      },
    ],
  },
  {
    path: "/absences",
    component: { render: (h) => h("router-view") },
    children: [
      {
        path: "",
        name: "AbsenceList",
        component: () => import("@/views/AbsencePage/AbsenceList.vue"),
        meta: {
          title: "Liste des absences",
          authenticationRequired: true,
          requiredPermissions: ["MANAGER", "SUPERVISOR"],
        },
      },
      {
        path: "ajouter",
        name: "AbsenceForm",
        component: () => import("@/views/AbsencePage/AbsenceForm.vue"),
        meta: {
          title: "Ajouter une absence",
          authenticationRequired: true,
          requiredPermissions: ["MANAGER", "SUPERVISOR"],
        },
      },
      {
        path: ":id",
        name: "AbsenceEditForm",
        component: () => import("@/views/AbsencePage/AbsenceForm.vue"),
        meta: {
          title: "Modifier une absence",
          authenticationRequired: true,
          requiredPermissions: ["MANAGER", "SUPERVISOR"],
        },
      },
      {
        path: ":absenceId/niveaux",
        name: "AbsenceLevelList",
        component: () => import("@/views/AbsencePage/AbsenceLevelList.vue"),
        meta: {
          title: "Niveaux d'absence",
          authenticationRequired: true,
          requiredPermissions: ["MANAGER", "SUPERVISOR"],
        },
      },
      {
        path: ":absenceId/niveaux/ajouter",
        name: "AbsenceLevelForm",
        component: () => import("@/views/AbsencePage/AbsenceLevelForm.vue"),
        meta: {
          title: "Ajouter un niveau d'absence",
          authenticationRequired: true,
          requiredPermissions: ["MANAGER", "SUPERVISOR"],
        },
      },
    ],
  },
  {
    path: "/espace-gestionnaire",
    name: "GestionnairePage",
    component: GestionnairePage,
    meta: {
      title: "Espace Gestionnaire",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/espace-gestionnaire2",
    name: "GestionnairePage2",
    component: GestionnairePage2,
    meta: {
      title: "Espace Gestionnaire",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/espace-convive",
    name: "ConvivePage",
    component: ConvivePage,
    meta: {
      title: "Espace Convive",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/espace-convive2",
    name: "ConvivePage2",
    component: ConvivePage2,
    meta: {
      title: "Espace Convive",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/espace-nutritioniste",
    name: "NutritionistePage",
    component: NutritionistePage,
    meta: {
      title: "Espace Nutritioniste",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/espace-nutritioniste2",
    name: "NutritionistePage2",
    component: NutritionistePage2,
    meta: {
      title: "Espace Nutritioniste",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/",
    meta: {
      home: true,
    },
  },
  {
    path: "/accueil",
    name: "LandingPage",
    component: LandingPage,
  },
  // {
  //   path: "/accueil2",
  //   name: "LandingPage",
  //   component: LandingPage,
  // },
  // {
  //   path: "/accueil3",
  //   name: "LandingPageAll2",
  //   component: LandingPageAll2,
  // },
  {
    path: "/blank-page-(test)",
    name: "BlankPage",
    component: BlankPage,
  },
  {
    path: "/actions",
    name: "ActionPlan",
    component: ActionPlan,
    meta: {
      title: "Plan d'actions",
      authenticationRequired: true,
      // Le convive accède au plan d'actions pour voir et répondre aux études/défis
      // auxquels il participe (tâche 4.1). L'API filtre déjà sur les rôles effectifs.
      // `NUTRITIONIST` y figure parce qu'`ActionsView.get_queryset` lui répond explicitement :
      // sans lui ici, le menu du nutritionniste menait à une redirection alors que l'API était
      // prête à le servir.
      requiredPermissions: ["MANAGER", "SUPERVISOR", "CONSUMER", "NUTRITIONIST"],
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/actions/create",
    name: "CreateAction",
    component: CreateAction,
    meta: {
      title: "Ajouter une action",
      authenticationRequired: true,
      requiredPermissions: ["MANAGER", "SUPERVISOR", "RESEARCHER"],
    },
  },
  {
    path: "/actions/:id/details",
    name: "ActionDetails",
    component: ActionDetails,
    meta: {
      title: "Instructions",
      authenticationRequired: true,
      requiredPermissions: ["MANAGER", "SUPERVISOR", "CONSUMER"],
    },
  },
  {
    path: "/contact",
    name: "ContactLabSoft",
    component: ContactLabSoft,
    meta: {
      title: "Contact",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    // Restitution cadree sur une activite : deux campagnes batties sur la meme recommandation
    // menaient auparavant au meme ecran, celui de `djf_surveys`, ouvert aux seuls auteurs.
    path: "/actions/:id/resultats",
    name: "ActionResults",
    component: ActionResults,
    meta: {
      title: "Résultats de l'activité",
      authenticationRequired: true,
      requiredPermissions: ["MANAGER", "SUPERVISOR"],
    },
  },
  {
    path: "/results",
    name: "ManageResults",
    component: ManageResults,
    meta: {
      authenticationRequired: true,
      requiredPermissions: ["MANAGER", "SUPERVISOR"],
    },
  },
  {
    path: "/accueil-gestionnaire",
    name: "ManagerLanding",
    component: ManagerLanding,
    beforeEnter: (_to, _from, next) => {
      store.state.loggedUser ? next({ path: "/" }) : next()
    },
  },
  {
    path: "/mon-compte",
    name: "AccountSummaryPage",
    component: AccountSummaryPage,
    redirect: { name: "AccountEditor" },
    children: [
      {
        path: "profil",
        name: "AccountEditor",
        component: AccountEditor,
        meta: {
          authenticationRequired: true,
          title: "Mon compte",
        },
        sitemapGroup: Constants.SitemapGroups.SITE,
      },
      {
        path: "mot-de-passe",
        name: "PasswordChange",
        component: PasswordChangeEditor,
        meta: {
          authenticationRequired: true,
          title: "Changer mon mot de passe",
        },
      },
      {
        path: "supprimer-mon-compte",
        name: "AccountDeletion",
        component: AccountDeletion,
        meta: {
          authenticationRequired: true,
          title: "Supprimer mon compte",
        },
      },
    ],
  },
  {
    path: "/diagnostic",
    name: "DiagnosticPage",
    component: DiagnosticPage,
    meta: {
      title: "M'auto-évaluer",
    },
    beforeEnter: (_to, _from, next) => {
      store.state.loggedUser ? next({ path: "/" }) : next()
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/creation-affiche",
    name: "GeneratePosterPage",
    component: GeneratePosterPage,
    meta: {
      title: "Affiche convives",
    },
    //sitemapGroup: Constants.SitemapGroups.ACTION,
  },
  {
    path: "/mesures-phares",
    name: "KeyMeasuresPage",
    component: KeyMeasuresPage,
    redirect: { name: "KeyMeasuresHome" },
    children: [
      {
        path: "",
        name: "KeyMeasuresHome",
        component: KeyMeasuresHome,
        meta: {
          title: "Tableau de bord",
        },
        beforeEnter: (route, _, next) => {
          store.state.loggedUser
            ? next({
                name: "KeyMeasurePage",
                params: {
                  id: "qualite-des-produits",
                },
              })
            : next()
        },
      },
      {
        path: ":id",
        name: "KeyMeasurePage",
        component: KeyMeasurePage,
        props: true,
      },
    ],
    meta: {
      title: "Les mesures phares",
    },
  },
  {
    path: "/trouver-une-cantine",
    name: "CanteenSearchLanding",
    component: CanteenSearchLanding,
    meta: {
      title: "Trouver une cantine",
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    // if you change this path, update the visitor view count logic in the publication widget
    path: "/nos-cantines",
    component: CanteensPage,
    children: [
      {
        path: "",
        name: "CanteensHome",
        component: CanteensHome,
        meta: {
          title: "Les cantines",
        },
      },
      {
        path: ":canteenUrlComponent",
        name: "CanteenPage",
        component: CanteenPage,
        props: true,
      },
    ],
  },
  {
    path: "/widgets/nos-cantines/:canteenUrlComponent",
    name: "CanteenWidget",
    component: CanteenWidget,
    props: true,
  },
  {
    path: "/mentions-legales",
    name: "LegalNotices",
    component: LegalNotices,
    meta: {
      title: "Mentions légales",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/blog",
    component: BlogsPage,
    children: [
      {
        path: "",
        name: "BlogsHome",
        component: BlogsHome,
        meta: {
          title: "Blog",
        },
        // sitemapGroup: Constants.SitemapGroups.LAW,
      },
      {
        path: ":id",
        name: "BlogPage",
        component: BlogPage,
        props: true,
      },
    ],
  },
  // {
  //   path: "/actions-anti-gaspi",
  //   component: WasteActionsPage,
  //   children: [
  //     {
  //       path: "",
  //       name: "WasteActionsHome",
  //       component: WasteActionsHome,
  //       meta: {
  //         title: "Actions anti-gaspi",
  //       },
  //       sitemapGroup: Constants.SitemapGroups.ACTION,
  //     },
  //     {
  //       path: ":id",
  //       name: "WasteActionPage",
  //       component: WasteActionPage,
  //       props: true,
  //     },
  //   ],
  // },
  {
    path: "/donner-ou-voir-mes-avis",
    component: SurveyLinksPage,
    children: [
      {
        path: "",
        name: "SurveyLinksHome",
        component: SurveyLinksHome,
        meta: {
          title: "Donner ou voir mes avis",
        },
        sitemapGroup: Constants.SitemapGroups.CONSUMER,
      },
    ],
  },
  {
    path: "/partenaires",
    redirect: "/acteurs-de-l-eco-systeme",
  },
  {
    path: "/acteurs-de-l-eco-systeme",
    component: PartnersPage,
    children: [
      {
        path: "",
        name: "PartnersHome",
        component: PartnersHome,
        meta: {
          title: "Acteurs de l'éco-système",
        },
        //sitemapGroup: Constants.SitemapGroups.ACTION,
      },
      {
        path: ":partnerUrlComponent",
        name: "PartnerPage",
        component: PartnerPage,
        props: true,
      },
    ],
  },
  {
    path: "/nouveau-acteur-de-l-ecosysteme",
    name: "NewPartner",
    component: NewPartner,
    meta: {
      title: "Nouvel acteur de l'éco-système",
    },
    //sitemapGroup: Constants.SitemapGroups.ACTION,
  },
  {
    path: "/cgu",
    name: "CGU",
    component: CGU,
    meta: {
      title: "Conditions générales d'utilisation",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/politique-de-confidentialite",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: {
      title: "Politique de confidentialité",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/mes-cantines",
    name: "MyCanteensSpace",
    component: ManagementPage,
    meta: {
      title: "Mes cantines",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    // Ancienne URL de l'espace, héritée d'upstream et diffusée en favori : la casser serait une
    // régression silencieuse. Pas d'entrée de sitemap — c'est une redirection, pas une page.
    path: "/gestion",
    redirect: { name: "MyCanteensSpace" },
  },
  {
    path: "/actions-en-attente",
    name: "PendingActions",
    component: PendingActions,
    meta: {
      title: "Actions en attente",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.ACTION,
  },
  {
    path: "/nouvelle-cantine",
    name: "NewCanteen",
    component: CanteenEditor,
    redirect: { name: "NewCanteenForm" },
    children: [
      {
        path: "",
        name: "NewCanteenForm",
        component: CanteenForm,
        meta: {
          title: "Ajouter ma cantine",
          authenticationRequired: true,
        },
        //sitemapGroup: Constants.SitemapGroups.ACTION,
      },
    ],
  },
  {
    path: "/eating-experience",
    name: "EatingExperiencePage",
    component: EatingExperiencePage,
    meta: {
      title: "Solutions répertoriées",
      authenticationRequired: true,
      requiredPermissions: ["CONSUMER", "NUTRITIONIST", "RESEARCHER"],
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/eating-experience/create",
    name: "CreateEatingExperience",
    component: CreateEatingExperience,
    meta: {
      title: "Ajouter une solution",
      authenticationRequired: true,
      // Le référentiel s'écrit par ses auteurs, se lit par tous : le convive garde
      // `/eating-experience` mais pas sa création. L'API tranche pareillement
      // (`IsReferentialAuthor`) — la garde de routeur ne protège que l'écran. Le chercheur en est
      // un auteur depuis R2.
      requiredPermissions: ["NUTRITIONIST", "RESEARCHER"],
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/concerns",
    name: "ConcernsPage",
    component: ConcernsPage,
    meta: {
      title: "Préoccupation",
      authenticationRequired: true,
      // Le chercheur lit et écrit le référentiel depuis R2 : le lui refuser en lecture rendrait
      // son entrée de menu inatteignable.
      requiredPermissions: ["CONSUMER", "NUTRITIONIST", "RESEARCHER"],
    },
  },
  {
    path: "/concerns/create",
    name: "CreateConcerns",
    component: CreateConcerns,
    meta: {
      title: "Ajouter une préoccupation",
      authenticationRequired: true,
      requiredPermissions: ["NUTRITIONIST"],
    },
  },
  {
    path: "/study-eating",
    component: EatingStudyPage,
    children: [
      {
        path: "/study-eat",
        name: "EatingStudyHome",
        component: EatingStudyHome,
        meta: {
          title: "Actions en cours",
          authenticationRequired: true,
          requiredPermissions: ["CONSUMER", "NUTRITIONIST"],
        },
        sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
      },
      {
        path: "/create",
        name: "CreateEatingStudy",
        component: CreateEatingStudy,
        meta: {
          title: "Déployer une action",
          authenticationRequired: true,
          // Déployer, c'est écrire sur une cantine : le gestionnaire y a sa place, le convive
          // non. L'API vérifie le rattachement effectif, pas la profession déclarée.
          requiredPermissions: ["NUTRITIONIST", "MANAGER"],
        },
        sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
      },
    ],
  },
  // {
  //   path: "/ceate-study-eating",
  //   component: EatingStudyPage,
  //   children: [
  //     {
  //       path: "",
  //       name: "CreateEatingStudy",
  //       component: CreateEatingStudy,
  //       meta: {
  //         title: "create-study-eating",
  //       },
  //       // sitemapGroup: Constants.SitemapGroups.LAW,
  //     },
  //   ],
  // },
  {
    path: "/modifier-ma-cantine/:canteenUrlComponent",
    name: "CanteenModification",
    props: true,
    component: CanteenEditor,
    redirect: { name: "CanteenForm" },
    children: [
      {
        path: "modifier",
        name: "CanteenForm",
        props: true,
        component: CanteenForm,
        meta: {
          authenticationRequired: true,
          title: "Modifier ma cantine",
        },
      },
      {
        path: "satellites",
        name: "SatelliteManagement",
        component: SatelliteManagement,
        meta: {
          authenticationRequired: true,
          title: "Gérer mes satellites",
        },
      },
      {
        path: "gestionnaires",
        name: "CanteenManagers",
        component: CanteenManagers,
        meta: {
          authenticationRequired: true,
          title: "Gérer mon équipe",
          requiredPermissions: ["MANAGER"],
        },
      },
      {
        path: "equipe",
        name: "CanteenStaff",
        component: CanteenStaff,
        meta: {
          authenticationRequired: true,
          title: "Superviseurs et employés",
          requiredPermissions: ["MANAGER"],
        },
      },
      {
        path: "convives",
        name: "CanteenConsumers",
        component: CanteenConsumers,
        meta: {
          authenticationRequired: true,
          title: "Convives",
          requiredPermissions: ["MANAGER"],
        },
      },
      {
        path: "generer-mon-affiche",
        name: "CanteenGeneratePoster",
        component: CanteenGeneratePoster,
        meta: {
          authenticationRequired: true,
          title: "Générer mon affiche",
        },
      },
      {
        path: "supprimer",
        name: "CanteenDeletion",
        component: CanteenDeletion,
        meta: {
          authenticationRequired: true,
          title: "Supprimer ma cantine",
        },
      },
      {
        path: "publier",
        name: "PublicationForm",
        component: PublicationForm,
        meta: {
          authenticationRequired: true,
          title: "Éditer mon affiche",
        },
      },
      {
        path: "publier-mes-satellites",
        name: "PublishSatellites",
        component: PublishSatellites,
        meta: {
          authenticationRequired: true,
          title: "Publier mes satellites",
        },
      },
    ],
  },
  {
    path: "/diagnostic-tunnel/:canteenUrlComponent/:year/:measureId",
    name: "DiagnosticTunnel",
    component: DiagnosticTunnel,
    props: true,
    meta: {
      title: "Bilan",
      authenticationRequired: true,
      fullscreen: true,
    },
  },
  {
    path: "/importer-diagnostics",
    name: "DiagnosticsImporter",
    component: DiagnosticsImporter,
    meta: {
      title: "Importer des diagnostics",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/importer-diagnostics/:importUrlSlug",
    name: "DiagnosticImportPage",
    component: DiagnosticImportPage,
    props: true,
  },
  {
    path: "/statistiques-regionales",
    name: "PublicCanteenStatisticsPage",
    component: PublicCanteenStatisticsPage,
    meta: {
      title: "Les cantines dans ma collectivité",
    },
    //sitemapGroup: Constants.SitemapGroups.LAW,
  },
  {
    path: "/accessibilite",
    name: "AccessibilityDeclaration",
    component: AccessibilityDeclaration,
    meta: {
      title: "Déclaration d'accessibilité",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/contact-old",
    name: "ContactPage",
    component: ContactPage,
    meta: {
      title: "Contactez-nous",
    },
    //sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/mes-achats",
    name: "PurchasesHome",
    component: PurchasesHome,
    meta: {
      title: "Mes achats",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/mes-achats/:id",
    name: "PurchasePage",
    component: PurchasePage,
    props: true,
    meta: {
      title: "Modifier mon achat",
      authenticationRequired: true,
    },
  },
  {
    path: "/nouvel-achat/",
    name: "NewPurchase",
    component: PurchasePage,
    meta: {
      title: "Nouvel achat",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/importer-achats",
    name: "PurchasesImporter",
    component: PurchasesImporter,
    meta: {
      title: "Importer des achats",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/synthese-achats",
    name: "PurchasesSummary",
    component: PurchasesSummary,
    meta: {
      title: "Synthèse des achats",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/communaute/",
    name: "CommunityPage",
    component: CommunityPage,
    meta: {
      title: "Webinaires",
    },
    //sitemapGroup: Constants.SitemapGroups.LAW,
  },
  {
    path: "/faq/",
    name: "FaqPage",
    component: FaqPage,
    meta: {
      title: "Foire aux questions",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/plan-du-site/",
    name: "SiteMap",
    component: SiteMap,
    meta: {
      title: "Plan du site",
    },
  },
  {
    path: "/developpement-et-apis/",
    name: "DeveloperPage",
    component: DeveloperPage,
    meta: {
      title: "Développement et APIs",
    },
    //sitemapGroup: Constants.SitemapGroups.ACTION,
  },
  {
    path: "/statistiques-plateforme/",
    name: "ImpactMeasuresPage",
    component: ImpactMeasuresPage,
    meta: {
      title: "Mesures de notre impact",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/webinaires/:webinaireUrlComponent",
    name: "VideoTutorial",
    component: VideoTutorial,
    props: true,
  },
  {
    path: "/les-cantines-de-mon-territoire",
    name: "TerritoryCanteens",
    component: TerritoryCanteens,
    meta: {
      title: "Les cantines de mon territoire",
      authenticationRequired: true,
    },
    beforeEnter: (_to, _from, next) => {
      store.state.loggedUser?.isElectedOfficial ? next() : next({ path: "/" })
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/mon-restaurant/tableau-de-bord",
    name: "RestaurantDashboardPage",
    component: RestaurantDashboardPage,
    meta: {
      title: "Mon tableau de bord",
    },
  },
  {
    path: "/diagnostic-gaspillage",
    name: "WasteDiagnosticPage",
    component: WasteDiagnosticPage,
    meta: {
      title: "Diagnostic gaspillage",
      // L'écran lit et écrit le diagnostic d'un établissement : il n'avait aucune garde tant
      // qu'il n'était branché sur rien. Le périmètre d'écriture du backend est « gestionnaire ou
      // membre de la cantine » ; la garde reprend les trois rôles qui peuvent l'être.
      authenticationRequired: true,
      requiredPermissions: ["MANAGER", "COOK", "SUPERVISOR"],
    },
  },
  {
    path: "/resume-diagnostic-gaspillage",
    name: "WasteDiagnosticResumePage",
    component: WasteDiagnosticResumePage,
    meta: {
      title: "Résumé Diagnostic Gaspillage",
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/nouveau-dashboard-cantine/:canteenId",
    name: "CantineNewDashboard",
    component: CantineNewDashboard,
    props: true,
    meta: {
      title: "Nouveau Dashboard Cantine",
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/campagne-gaspillage/:canteenId",
    name: "WasteCampaignTunnel",
    component: () => import("@/views/WasteCampaignTunnel"),
    props: true,
    meta: {
      title: "Campagne de mesure du gaspillage",
      authenticationRequired: true,
      // Le périmètre d'écriture du backend est « gestionnaire ou membre de la cantine » : la
      // garde reprend les trois rôles qui peuvent l'être. Elle filtre l'accès à la page, pas
      // à la cantine — c'est l'API qui refuse une cantine hors périmètre.
      requiredPermissions: ["MANAGER", "COOK", "SUPERVISOR"],
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/kezako",
    name: "KezakoPage",
    component: KezakoPage,
    meta: {
      title: "Kezako ?",
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/nutriquest",
    name: "NutriQuest",
    component: NutriQuest,
    meta: {
      title: "NutriQuest",
      authenticationRequired: true,
      requiredPermissions: ["CONSUMER"],
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    // L'identifiant est dans l'URL et passé en `props` : la page ne lit pas `$route` elle-même,
    // ce qui la rend montable en test sans routeur.
    path: "/nutriquest/module/:actionId",
    name: "PedagogicalModulePage",
    component: () => import("@/views/PedagogicalModulePage/index.vue"),
    props: true,
    meta: {
      title: "Module pédagogique",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    // Le sommaire d'un cours. Une partie ouverte hors de son cours — lien direct, cours en
    // brouillon — sait y revenir : la carte porte son `courseId`.
    path: "/nutriquest/cours/:courseId",
    name: "CoursePage",
    component: () => import("@/views/CoursePage/index.vue"),
    props: true,
    meta: {
      title: "Cours",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/nutriquest/chapitre/:chapterId",
    name: "CourseChapterPage",
    component: () => import("@/views/CourseChapterPage/index.vue"),
    props: true,
    meta: {
      title: "Chapitre",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/nutriquest/cours/:courseId/attestation",
    name: "CourseCertificatePage",
    component: () => import("@/views/CourseCertificatePage/index.vue"),
    props: true,
    meta: {
      title: "Attestation",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    // L'atelier est ouvert au superviseur : l'habilitation pédagogique est portée par le
    // rattachement à un établissement, pas par le rôle, et seul le serveur la connaît. Un
    // superviseur non habilité accède à la page et n'y trouve rien — c'est voulu : refuser
    // côté client demanderait de dupliquer ici une règle qui vit dans la base.
    path: "/atelier-des-cours",
    name: "CourseStudioPage",
    component: () => import("@/views/CourseStudioPage/index.vue"),
    meta: {
      title: "Atelier des cours",
      authenticationRequired: true,
      requiredPermissions: ["SUPERVISOR"],
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/atelier-des-cours/:courseId",
    name: "CourseComposePage",
    component: () => import("@/views/CourseComposePage/index.vue"),
    props: true,
    meta: {
      title: "Composition du cours",
      authenticationRequired: true,
      requiredPermissions: ["SUPERVISOR"],
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/atelier-des-cours/chapitre/:chapterId",
    name: "CourseChapterEditorPage",
    component: () => import("@/views/CourseChapterEditorPage/index.vue"),
    props: true,
    meta: {
      title: "Écriture du chapitre",
      authenticationRequired: true,
      requiredPermissions: ["SUPERVISOR"],
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/mon-assiette",
    name: "MyDishPage",
    component: () => import("@/views/MyDishPage.vue"),
    meta: {
      title: "Mon assiette",
      authenticationRequired: true,
      requiredPermissions: ["CONSUMER"],
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/eating-issue-prediction",
    name: "EatingIssuePrediction",
    component: () => import("@/views/EatingIssuePrediction.vue"),
    meta: {
      title: "Prédiction des problématiques alimentaires",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/next-meeting-calendar",
    name: "NextMeeting",
    component: NextMeeting,
    meta: {
      title: "Prochain RDV",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
]

if (window.ENABLE_DASHBOARD) {
  routes.push({
    path: "/dashboard/:canteenUrlComponent",
    name: "DashboardManager",
    component: DashboardManager,
    props: true,
    meta: {
      title: "Tableau de bord",
      authenticationRequired: true,
    },
  })
  routes.push({
    path: "/ma-progression/:canteenUrlComponent/:year/:measure",
    name: "MyProgress",
    component: MyProgress,
    props: true,
    meta: {
      title: "Ma progression",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  })
}

routes.push({
  path: "/:catchAll(.*)",
  component: NotFound,
  name: "NotFound",
})

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) return { selector: to.hash, offset: { y: 200 } }
    if (to.name === from.name && this.app.$vuetify.breakpoint.mdAndUp) return savedPosition
    return { x: 0, y: 0 }
  },
})

// L'autorisation se lit sur les rôles effectifs (rattachements + professions hors pivot),
// jamais sur `loggedUser.job` : déclarer une profession ne donne aucun droit.
function isRouteAuthorized(to) {
  const requiredPermissions = to.meta && to.meta.requiredPermissions
  if (!requiredPermissions) return true
  const userRoles = store.getters.userRoles
  return requiredPermissions.some((permission) => userRoles.includes(permission))
}

function goToRoute(to, next) {
  if (isRouteAuthorized(to)) {
    next()
  } else {
    next({ path: "/" })
  }
}

function chooseAuthorisedRoute(to, next) {
  const user = store.state.loggedUser
  const userRoles = store.getters.userRoles
  // Une invitation en attente doit être confirmée par code : c'est la confirmation qui crée
  // le rattachement, donc l'accès. Aucun besoin de tester `job` pour le savoir.
  const needsConfirmation = user && user.hasPendingStaffInvitation && to.path !== "/confirmer-association/"
  if (needsConfirmation) {
    window.location.href = "/confirmer-association/"
    return
  }
  // Noms de routes canoniques (nettoyage des PoC), aiguillage sur les rôles réellement
  // détenus et non sur `job` : un utilisateur peut cumuler plusieurs rôles.
  if (to.meta.home && userRoles.includes("MANAGER")) next({ name: "ManagerDashboard" })
  else if (to.meta.home && userRoles.includes("SUPERVISOR")) next({ name: "SupervisorDashboard" })
  else if (to.meta.home && userRoles.includes("WORKER")) next({ name: "WorkerDashboard" })
  else if (to.meta.home && userRoles.includes("COOK")) next({ name: "CookDashboard" })
  else if (to.meta.home && userRoles.includes("NUTRITIONIST")) next({ name: "NutritionistDashboard" })
  else if (to.meta.home && userRoles.includes("SURPLUSMANAGER")) next({ name: "SurplusManagerDashboard" })
  // Le convive rejoint son dashboard. L'aiguillage vers NutriQuest quand
  // `show_dashboard` est inactif se fait dans la vue, d'après la cantine sélectionnée
  // (un convive peut être rattaché à plusieurs cantines de flags différents).
  else if (to.meta.home && userRoles.includes("CONSUMER")) next({ name: "ConsumerDashboard" })
  else if (to.meta.home && user && !user.isStaff) next({ name: "SurveyLinksHome" })
  // Le repli d'un membre du staff sans rôle métier visait `ManagementPage`. Il tombe désormais sur
  // `LandingPage` comme tout utilisateur sans destination propre : renvoyer ici vers `/` boucle,
  // puisque nous sommes dans le résolveur de `home`.
  else if (to.meta.home && user && user.isDev) next({ name: "DeveloperPage" })
  else if (to.meta.home) next({ name: "LandingPage" })
  else if (!to.meta.authenticationRequired || user) goToRoute(to, next)
  else window.location.href = `/s-identifier?next=${to.path}`
}

router.beforeEach((to, from, next) => {
  store.dispatch("removeNotifications")

  // si les données du store ne sont pas encore chargées
  if (!store.state.initialDataLoaded) {
    store
      .dispatch("fetchInitialData")
      .then(() => {
        chooseAuthorisedRoute(to, next)
      })
      .catch((e) => {
        console.error(`An error occurred: ${e}`)
        next({ name: "LandingPage" })
      })
  } else {
    chooseAuthorisedRoute(to, next)
  }
  // TODO: audit code to check that notifies are placed after redirects
  // TODO: check the tunnel to see if the change of step also clears notifications
})

export { router, routes }
